import React, {useContext, useState} from "react";
import {Form as FormikForm} from "../components/forms";
import ProjectContext from "../utils/context"
import portalApi from "../api/portal";
import notyfApi from "../utils/notyfApi";
import Overview from "../components/tabs/Overview";

// Overview handler get the data and sets it into the formik context.
const OverviewHandler = () => {
    const {project, setProject} = useContext(ProjectContext)
    const [dirty, setDirty] = useState(false)// For if the form has been edited

    const handleSubmit = async (values) => {
        const id = window.location.pathname.split("/")[1]
        setProject(values) // Update the project context
        const res = await portalApi.putProject(id, values)
        if (res.ok) notyfApi.success("Opgeslagen")
        else notyfApi.error("Er ging iets mis met opslaan")
    }

    return (
        <FormikForm
            initialValues={project}
            enableReinitialize={true}
            onSubmit={handleSubmit}
        >
            <Overview setDirty={setDirty}/>
        </FormikForm>
    )
}

export default OverviewHandler;